import React from 'react';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { useMediaQuery } from 'react-responsive';
import { RootState } from '@Redux/search/store';
import { useSelector } from 'react-redux';

export interface I_CustomTableProps {
    /** 表格的標題陣列*/
    titles: { name: string; key: string; size?: string }[];
    /** 資料集陣列*/
    tableElement: JSX.Element[];
    className?: string;
}
// pageReducer

export const CustomTable: React.FC<I_CustomTableProps> = (props) => {
    const { titles, tableElement, className } = props;
    const isPC = useMediaQuery({ query: '(min-width: 980px)' });
    const { curPage } = useSelector((state: RootState) => state.pageReducer);
    const isPrint = curPage === 'print';

    return (
        <div
            className={cN(
                styles.customCollapseList,
                styles.customTable,
                className || '',
                'customTable'
            )}
        >
            {(isPC || isPrint) && (
                <div className={styles.customRow}>
                    <div className={cN(styles.customHeader)}>
                        {titles.map((title) => {
                            return (
                                <p
                                    className={cN(styles.customTitle, 'customTitle')}
                                    style={{ width: title.size }}
                                    key={`title_${title.key}`}
                                >
                                    {title.name}
                                </p>
                            );
                        })}
                    </div>
                </div>
            )}
            {tableElement.map((element, i) => {
                return (
                    <div key={i} className={styles.customRow}>
                        <div className={cN(styles.customContent, 'customContent')}>{element}</div>
                    </div>
                );
            })}
        </div>
    );
};
